import React from 'react'

const BootstrapLoader = ({areaHeight}) => {
    return (
        <div style={{ height: `${areaHeight}px` }} className="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default BootstrapLoader